import { ShopperAgentTraceSchema } from "@redotech/redo-shopper-agent-common/trace";
import * as z from "zod";

const conversationSchema = z.object({
  observedAt: z.date(),
  seed: z.object({
    kind: z.enum([
      "marketing_conversation",
      "channel_thread",
      "shopper_agent_conversation",
      "raw_id",
    ]),
    id: z.string(),
  }),
  /** Several when one Marketing conversation spans more than one thread. */
  candidates: z.array(
    z.object({
      channelThreadId: z.string(),
      rawChannelThreadId: z.string(),
      channel: z.string(),
      team: z.object({ id: z.string(), name: z.string() }),
      messageCount: z.number(),
      exactMarketingBridgeCount: z.number(),
      lastMessageAt: z.date().nullable(),
      sources: z.array(
        z.enum([
          "channel_thread",
          "shopper_agent_conversation",
          "marketing_support_message",
          "marketing_support_draft",
          "shopper_agent_metadata",
        ]),
      ),
    }),
  ),
});

export const resolveShopperAgentObservability = {
  name: "resolveShopperAgentObservability" as const,
  /** A pasted message, draft or conversation id. */
  input: z.object({ id: z.string() }),
  output: z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("trace"), trace: ShopperAgentTraceSchema }),
    // Flat, so an admin tab loaded before this shipped still reads it.
    conversationSchema.extend({ kind: z.literal("conversation") }),
    z.object({ kind: z.literal("unknown") }),
  ]),
};

export type ShopperAgentObservabilityConversation = z.infer<
  typeof conversationSchema
>;
